let timeInSecs;
let ticker;

export function startCountdownTimer(secs) {
    timeInSecs = parseInt(secs);
    ticker = setInterval(tick, 1000);
    document.getElementById("countdown_popup").style.display = "block";
    document.getElementById("countdown_overlay").style.display = "block";
}

function tick() {
    var secs = timeInSecs;
    if (secs > 0) {
        timeInSecs--;
    }
    else {
        clearInterval(ticker);
        document.getElementById("countdown_popup").style.display = "none";
        document.getElementById("countdown_overlay").style.display = "none";
    }

    secs %= 60;
    var pretty = (secs < 10) ? secs : secs;

    document.getElementById("countdown").innerHTML = "<p>Interview will start in</p>";
    document.getElementById("countdown").innerHTML += pretty;
}